// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"styles_sectionTitle__6Mitr","sectionTitleWithoutOver":"styles_sectionTitleWithoutOver__3L3RG","sectionTitlePolicy":"styles_sectionTitlePolicy__h942K"};